import { useSession } from "../session/SessionProvider.js";

export function useIsAdmin(): boolean {
  const { user } = useSession();
  return user?.role === "admin";
}

export function confirmAdmin(message: string): boolean {
  return window.confirm(message);
}
